function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3.107v.226a2.665 2.665 0 01-.786 1.894l-1.88 1.886a.9.9 0 01-1.267 0l-.066-.073a.333.333 0 010-.467l2.293-2.293a1.33 1.33 0 00.373-.947v-.226c0-.356-.141-.696-.393-.947l-.433-.433a1.333 1.333 0 00-.947-.394h-.227c-.355 0-.696.142-.946.394L5.427 4a.333.333 0 01-.466 0l-.074-.073a.9.9 0 010-1.267L6.774.767A2.667 2.667 0 018.667 0h.227C9.6 0 10.28.28 10.78.78l.44.44c.5.5.78 1.18.78 1.887zM3.767 7.293l3.527-3.526a.333.333 0 01.473 0l.467.466a.333.333 0 010 .474L4.706 8.233a.333.333 0 01-.473 0l-.467-.466a.333.333 0 010-.474zM7.04 8a.333.333 0 00-.467 0l-2.286 2.273a1.333 1.333 0 01-.954.394h-.226c-.356 0-.696-.142-.947-.394l-.433-.433a1.333 1.333 0 01-.394-.947v-.226c0-.356.142-.696.394-.947l2.28-2.293a.333.333 0 000-.467l-.074-.073a.9.9 0 00-1.266 0L.787 6.773A2.667 2.667 0 000 8.667V8.9c.001.705.282 1.381.78 1.88l.44.44c.5.5 1.18.78 1.887.78h.226a2.666 2.666 0 001.88-.76l1.9-1.9a.9.9 0 000-1.267L7.04 8z"
});

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    fill: "#D6D7E1"
  }, props), _ref);
};

export default SvgLink;